import { render, staticRenderFns } from "./LoyaltyMomentMetrics.vue?vue&type=template&id=003110d4&"
import script from "./LoyaltyMomentMetrics.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMomentMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports